import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService, translate } from '@jsverse/transloco';
@Pipe({
  name: 'primaryMuscles',
  standalone: true,
})
export class PrimaryMusclesPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(primaryMuscles: string[], activeLang?: string) {
    if (!primaryMuscles || primaryMuscles.length === 0) return;

    return primaryMuscles
      .map(p => this.translocoService.translate(p, {}, activeLang))
      .join(', ');
  }


  // transform(primaryMuscles: string[] | undefined, activeLang?: string) {
  //   if (!primaryMuscles || primaryMuscles.length === 0) return;

  //   return primaryMuscles.join(', ');

  //   // return translate(primaryMuscles, undefined, activeLang);
  // }
}
